import { useState } from 'react';
import Toggle from '../Toggle';


const EpikToggle = () => {
  const [showMyEpik2, setShowMyEpik2] = useState()

  const handleToggle = () => {
    if (!showMyEpik2) {
      setShowMyEpik2(!showMyEpik2);
      setTimeout(() => {
        window.location.href = 'https://my.epik.io/apps/epikv2/';
      }, 300);
    }
  };

  return (
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px'}}>
          <span
            style={{
              color: 'rgb(219, 66, 81)',
              marginRight: '6px'
            }}
          >
            Try the new MyEPIK 2.0 BETA
          </span>
          <Toggle value={showMyEpik2} onToggle={handleToggle} />
        </div>
      )

};

export default EpikToggle;
